import { NewspaperIcon } from "@heroicons/react/24/outline";
import { Article } from "../../api/LegacyReportsApi";
import { format } from "date-fns";
import ItemFlags from "../common/ItemFlags";

function LegacyArticleCard({ article }: { article: Article }) {
  return (
    <div className="bg-white p-4 pb-6 break-inside-avoid print:break-inside-avoid font-roboto font-light text-sm leading-normal text-gray-700 shadow-md w-full">
      <div className="flex items-start pb-4">
        <NewspaperIcon className="w-[32px] h-[32px] text-white bg-[#126798] p-[3.0px] rounded-sm flex-shrink-0" />
        <div className="flex-grow ml-3">
          <h4 className="text-xs tracking-wide text-[#146698] font-normal m-0">
            <a
              href={article.originalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              {article.title}
            </a>
          </h4>
          <span className="mt-0.5 font-roboto text-xs tracking-wide text-gray-500 flex items-center">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {article.contentFamaDate
              ? format(new Date(article.contentFamaDate), "MMM dd, yyyy")
              : ""}
          </span>
        </div>
      </div>

      <div className="font-roboto text-xs font-light tracking-wide text-gray-800 break-words">
        {article.text}
      </div>

      <hr className="my-4 border-t border-gray-200" />

      {(article.flaggedKeywords.length > 0 ||
        article.flaggedStemmableKeywords.length > 0 ||
        article.flaggedSensitivities.length > 0) && (
        <div>
          <ItemFlags
            behaviorFlags={article.flaggedSensitivities}
            keywordFlags={[
              ...article.flaggedKeywords,
              ...article.flaggedStemmableKeywords,
            ]}
          />
        </div>
      )}

      <div className="flex justify-end pt-4">
        <div className="text-right">
          <a
            href={article.originalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-medium tracking-wide text-blue-500 hover:text-blue-600 active:text-blue-700"
          >
            View link
          </a>
        </div>
      </div>
    </div>
  );
}

export default LegacyArticleCard;
